import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDiscountCodesLogsData } from "../../api/discounts/index.types";

export interface IDiscountCodesLogsState {
  data: IDiscountCodesLogsData;
  loading: boolean;
}

const initialState: IDiscountCodesLogsState = {
  data: {
    rows: [],
    count: 0,
  },
  loading: false,
};

const index = createSlice({
  name: "discountCodesLogs",
  initialState,
  reducers: {
    fetchRequest: (state) => {
      state.loading = true;
    },
    fetchSuccess: (state, action: PayloadAction<IDiscountCodesLogsData>) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchFailed: (state) => {
      state.loading = false;
    },
  },
});

export const discountCodesLogsActions = index.actions;
export default index.reducer;
